"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};

  /**
   * Конструктор плагина импорта товаров
   * @param {any} container Контейнер, в котором будет размещаться плагин
   */
  var ImportProducts = function ImportProducts(importButton, importInput, cancelImportButton) {
    var $importButton = importButton;
    var $visualImportInput = importInput;
    var $cancelImportButton = cancelImportButton;
    var _fileInput, _callback;
    var hiddenFileInputTemplate = function hiddenFileInputTemplate() {
      return $('<input/>').attr('id', $importButton.attr('id') + 'fileInput').attr('hidden', 'hidden').addClass('hidden').attr('type', 'file').attr('accept', '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel').change(fileImportChanged).blur(fileImportChanged);
    };
    function fileImportChanged(_x) {
      return _fileImportChanged.apply(this, arguments);
    }
    function _fileImportChanged() {
      _fileImportChanged = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var target, data, result, errors, _iterator, _step, error;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              target = event.target || event.srcElement;
              if (!(target.value.length == 0)) {
                _context.n = 1;
                break;
              }
              $importButton.removeAttr('disabled');
              if ($cancelImportButton) $cancelImportButton.attr('disabled', 'disabled');
              return _context.a(2);
            case 1:
              $importButton.attr('disabled', 'disabled');
              if ($cancelImportButton) $cancelImportButton.removeAttr('disabled');
              data = new FormData();
              data.append('uploadedFile', target.files[0]);
              if ($visualImportInput) $visualImportInput.val(target.files[0].name);
              $(target).val('');
              _context.n = 2;
              return $.b2b.ajax({
                url: '/Catalog/ParseImportedProducts',
                type: 'POST',
                data: data,
                cache: false,
                dataType: null,
                contentType: false,
                //stop jquery auto convert form type to default x-www-form-urlencoded
                processData: false
              }).always(function () {
                $importButton.removeAttr('disabled');
              });
            case 2:
              result = _context.v;
              errors = result.Data.Errors;
              if (!!errors) {
                _iterator = _createForOfIteratorHelper(errors);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    error = _step.value;
                    $.b2b.toastNotificationService.showError(error, {
                      timeout: 0
                    });
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              if (_callback) _callback(result.Data.ImportedProducts);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _fileImportChanged.apply(this, arguments);
    }
    function onImport(e) {
      e.stopPropagation();
      e.preventDefault();
      _fileInput.click();
    }
    function clearImport() {
      _fileInput.val('');
      if ($visualImportInput) $visualImportInput.val('');
      if ($cancelImportButton) $cancelImportButton.attr('disabled', 'disabled');
      if (_callback) _callback([]);
    }

    /**
     * Инициализировать рекомендации
     */
    this.init = function (callback) {
      $importButton.click(onImport);
      _fileInput = hiddenFileInputTemplate();
      $(document.body).append(_fileInput);
      if ($cancelImportButton) {
        $cancelImportButton.click(clearImport);
        $cancelImportButton.attr('disabled', 'disabled');
      }
      _callback = callback;
    };
  };

  /** Рекомендации B2B */
  $.b2b.importProducts = ImportProducts;
})(jQuery);